export const NAVIGATION_TOP_SEGMENT_NAME = 'navigation.top';
export const NAVIGATION_SIDEBAR_SEGMENT_NAME = 'navigation.sidebar';
export const NAVIGATION_SSR_MARK_PREFIX = 'nav-ssr-mark';

// NAVIGATION TOP MARKS
export const NAVIGATION_TOP_MARKS = {
	renderStart: 'navigation-top.render.start',
	renderEnd: 'navigation-top.render.end',
	renderSsrStart: 'navigation-top.render.ssr.start',
	renderSsrEnd: 'navigation-top.render.ssr.end',
	bundleLoadStart: 'navigation-top.bundle-load.start',
} as const;

// SIDEBAR MARKS
export const NAVIGATION_SIDEBAR_MARKS = {
	renderAttempt: 'navigation-sidebar.render.attempt',
	renderStart: 'navigation-sidebar.render.start',
	renderEnd: 'navigation-sidebar.render.end',
	renderSsrStart: 'navigation-sidebar.render.ssr.start',
	renderSsrEnd: 'navigation-sidebar.render.ssr.end',
	loadStart: 'navigation-sidebar.load.start',
	loadEnd: 'navigation-sidebar.load.end',
} as const;
